import React from "react";
import {
  QueryRaceData,
  SubscribeOffsetPreviewsUpdate,
  SubscribePitPreviewsUpdate,
  SubscribeRaceConfigUpdate,
  SubscribeLapTableUpdate,
  SubscribeLapUpdate,
  SubscribeOptimisationTriggerUpdate,
} from "../../../utils/graphql/hooks/raceDataHooks";

export default function RaceDataDataManager() {
  QueryRaceData();
  SubscribeLapTableUpdate();
  SubscribeLapUpdate();
  SubscribeRaceConfigUpdate();
  SubscribeOffsetPreviewsUpdate();
  SubscribePitPreviewsUpdate();
  SubscribeOptimisationTriggerUpdate();
  return <></>;
}
